import { UserDrawField } from '../../../components/DrawField'
import { BreadcrumbNavigation } from '../../../components/ImpactLayout'
import { GROWERS_ROUTES } from '../../../navigation/types/growersRoutes'
import { LAND_MANAGER_ROUTES } from '../../../navigation/types/routes'
import { useBreadcrumbs } from '../useBreadcrumbs'

export const GrowerDrawField = () => {
  const breadcrumbs = useBreadcrumbs()
  return (
    <>
      <BreadcrumbNavigation breadcrumbs={breadcrumbs} />
      <UserDrawField
        completeRoute={GROWERS_ROUTES.DETAIL}
        profilingRoute={LAND_MANAGER_ROUTES.PROFILE_FIELDS}
        enrollRoute={GROWERS_ROUTES.DETAIL}
      />
    </>
  )
}
